import React from 'react';
import { ThemeProvider } from './ThemeProvider';
import { QueryProvider } from './QueryProvider';
import { AuthProvider } from './AuthProvider';
import { AppDataProvider } from './AppDataProvider';
import { SnackbarProvider } from './SnackbarProvider';
import { SessionExpiredDialog } from '@/components/common/SessionExpiredDialog';

interface ProvidersProps {
  children: React.ReactNode;
}

export const Providers: React.FC<ProvidersProps> = ({ children }) => {
  return (
    <QueryProvider>
      <ThemeProvider>
        <SnackbarProvider>
          <AuthProvider>
            <AppDataProvider>{children}</AppDataProvider>
          </AuthProvider>
          <SessionExpiredDialog />
        </SnackbarProvider>
      </ThemeProvider>
    </QueryProvider>
  );
};

export { ThemeProvider, useThemeMode } from './ThemeProvider';
export { QueryProvider, queryClient } from './QueryProvider';
export { AuthProvider, useAuth } from './AuthProvider';
export { AppDataProvider, useAppData } from './AppDataProvider';
export { SnackbarProvider, useSnackbar } from './SnackbarProvider';
